import FocusLock from './Lock';
import AutoFocusInside from './AutoFocusInside';
import MoveFocusInside from './MoveFocusInside';
import FreeFocusInside from './FreeFocusInside';
import InFocusGuard from './FocusGuard';
export { AutoFocusInside, MoveFocusInside, FreeFocusInside, InFocusGuard };
export default FocusLock;


// WEBPACK FOOTER //
// ./node_modules/react-focus-lock/dist/es2015/index.js